/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M3.5 8.00012V3.00012L2 4.00006M3.5 8.00012H2M3.5 8.00012L5 8.00006M2.00024 15.0001H5.00024L5 17.5001H2V20.0001H5.00024"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M9.00024 20.0001L22.0002 20.0001M9.00024 12.0001L22.0002 12.0001M9.00024 4.00012H22.0002"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				d="M9.00022 20.0001L22.0002 20.0001M9.00022 12.0001L22.0002 12.0001M9.00022 4.0001H22.0002M3.50024 8.00021V3.00021L2.00024 4.00015M3.50024 8.00021H2.00024M3.50024 8.00021L5.00024 8.00015M2.00049 15.0002H5.00049L5.00024 17.5002H2.00024V20.0002H5.00049"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				d="M9 20H22M9 12L22 12M9 4H22M3.5 8V3L2 3.99994M3.5 8H2M3.5 8L5 7.99994M2.00024 15H5.00024L5 17.5H2V20H5.00024"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M9.0001 20.0001H16.0001M20.0001 20.0001H22.0001M9.0001 12.0001H22.0001M9.00012 4.00012H16.0001M20.0001 4.00012H22.0001M3.5 8.00012V3.00012L2 4.00006M3.5 8.00012H2M3.5 8.00012L5 8.00006M2.00024 15.0001H5.00024L5 17.5001H2V20.0001H5.00024"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M9.00024 20.0001H22.0002M9.00024 12.0001L22.0002 12.0001M9.00024 4.00012H22.0002M3.50024 8.00012V3.00012L2.00024 4.00006M3.50024 8.00012H2.00024M3.50024 8.00012L5.00024 8.00006M2.00049 15.0001H5.00049L5.00024 17.5001H2.00024V20.0001H5.00049"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				d="M9 20H22M9 12L22 12M9 4H22M3.5 8V3L2 3.99994M3.5 8H2M3.5 8L5 7.99994M2.00024 15H5.00024L5 17.5H2V20H5.00024"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
]);
